import { Box, Stack, Typography } from "@mui/material"

export function JsonBlock({ label, value }) {
    if (value === null || value === undefined) return null
    return (
        <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
                {label}
            </Typography>
            <Box
                component="pre"
                sx={{
                    m: 0,
                    p: 1,
                    bgcolor: "action.hover",
                    borderRadius: 1,
                    fontFamily: "monospace",
                    fontSize: 11,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                }}
            >
                {JSON.stringify(value, null, 2)}
            </Box>
        </Stack>
    )
}
